export default "__VITE_ASSET__CtMLnbBg__"